import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "instructionsOverlay", "instructionsContent",
    "timerOverlay", "timerNumber",
    "questionsOverlay", "questionsContent",
    "homepageContent", "durationInput",
    "viewportWidthInput", "viewportHeightInput",
    "screenWidthInput", "screenHeightInput",
    "userAgentInput", "refInput"
  ]

  connect() {
    this.testStartTime = null
    this.testEndTime = null
    this.captureBrowserInfo()
  }

  captureBrowserInfo() {
    // Capture viewport dimensions
    if (this.hasViewportWidthInputTarget) {
      this.viewportWidthInputTarget.value = window.innerWidth
    }
    if (this.hasViewportHeightInputTarget) {
      this.viewportHeightInputTarget.value = window.innerHeight
    }

    // Capture screen dimensions
    if (this.hasScreenWidthInputTarget) {
      this.screenWidthInputTarget.value = window.screen.width
    }
    if (this.hasScreenHeightInputTarget) {
      this.screenHeightInputTarget.value = window.screen.height
    }

    // Capture user agent
    if (this.hasUserAgentInputTarget) {
      this.userAgentInputTarget.value = navigator.userAgent
    }
  }

  async startTest() {
    // Record start time
    this.testStartTime = Date.now()

    // Hide instructions modal
    this.instructionsOverlayTarget.classList.remove("modal-visible")
    await this.sleep(300) // Wait for fade out
    this.instructionsOverlayTarget.classList.add("hidden")

    // Show homepage content
    this.homepageContentTarget.classList.remove("hidden")

    // Wait 5 seconds
    await this.sleep(5000)

    // Record end time
    this.testEndTime = Date.now()

    // Hide homepage
    this.homepageContentTarget.classList.add("hidden")

    // Show questions modal directly
    this.questionsOverlayTarget.classList.remove("hidden")
    this.questionsOverlayTarget.classList.add("modal-visible")

    // Set actual duration in hidden field
    if (this.hasDurationInputTarget) {
      const duration = this.testEndTime - this.testStartTime
      this.durationInputTarget.value = duration
    }
  }

  async countdown() {
    const numbers = [3, 2, 1]

    for (let i = 0; i < numbers.length; i++) {
      this.timerNumberTarget.textContent = numbers[i]
      this.timerNumberTarget.classList.remove("number-animate")

      // Force reflow
      void this.timerNumberTarget.offsetWidth

      await this.sleep(50)
      this.timerNumberTarget.classList.add("number-animate")

      if (i < numbers.length - 1) {
        await this.sleep(950)
      } else {
        await this.sleep(450)
      }
    }
  }

  closeQuestionsModal() {
    // Fade out questions modal
    this.questionsOverlayTarget.classList.remove("modal-visible")

    // After fade, show homepage content
    setTimeout(() => {
      this.questionsOverlayTarget.classList.add("hidden")
      this.homepageContentTarget.classList.remove("hidden")
    }, 300)
  }

  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms))
  }
}
